<div
  *ngIf="orders.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="orders"
    class="sp-width__full">
    <ng-container matColumnDef="order_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ORDER_ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <app-shared-id
          [content]="order.order_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.CREATED_AT_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.created_at"
          class="sp-text__ellipsized">
          {{ order.created_at | date : 'short' }}
        </span>

        <span *ngIf="!order.created_at"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="completed_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.COMPLETED_AT_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.running_at"
          class="sp-text__ellipsized">
          {{ order.running_at | date : 'short' }}
        </span>

        <span
          *ngIf="order.canceled_at"
          class="sp-text__ellipsized">
          {{ order.canceled_at | date : 'short' }}
        </span>

        <span *ngIf="!order.running_at && !order.canceled_at"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="qinetic">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">Qinetic ID</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <div
            class="sp-circle__xs"
            [ngClass]="order.liquidated_at ? 'sp-background__status-50' : 'sp-background__status-400'"></div>
          <app-shared-id
            *ngIf="order.position_id"
            [content]="order.position_id"
            [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover sp-color__green sp-text__bold'"
            [is_shrinked_id]="false"
            (content_click)="onQineticClick(order)"></app-shared-id>

          <button
            *ngIf="!order.position_id && order.position_error"
            (click)="onPositionErrorClick(order); $event.stopPropagation()"
            mat-icon-button>
            <mat-icon class="sp-color__warn"> bug_report </mat-icon>
          </button>

          <span
            class="sp-margin__left"
            *ngIf="!order.position_id && !order.position_error">
            -
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="BD1">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">BD1</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.bd1_result"
          (click)="onDecidoClick(order, order.bd1_evaluation_id); $event.stopPropagation()"
          [ngClass]="getEvaluationClass(order.bd1_result)"
          class="sp-text__ellipsized sp-text__hover sp-text__bold">
          {{ order.bd1_result | uppercase }}
        </span>
        <app-shared-id
          *ngIf="!order.bd1_result && order.bd1_evaluation_id"
          (click)="onDecidoClick(order, order.bd1_evaluation_id); $event.stopPropagation()"
          [content]="order.bd1_evaluation_id"
          [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover'"
          [is_shrinked_id]="true"></app-shared-id>
        <span *ngIf="!order.bd1_result && !order.bd1_evaluation_id"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="BD2">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">BD2</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.bd2_result"
          (click)="onDecidoClick(order, order.bd2_evaluation_id); $event.stopPropagation()"
          [ngClass]="getEvaluationClass(order.bd2_result)"
          class="sp-text__ellipsized sp-text__hover sp-text__bold">
          {{ order.bd2_result | uppercase }}
        </span>
        <app-shared-id
          *ngIf="!order.bd2_result && order.bd2_evaluation_id"
          (click)="onDecidoClick(order, order.bd2_evaluation_id); $event.stopPropagation()"
          [content]="order.bd2_evaluation_id"
          [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover'"
          [is_shrinked_id]="true"></app-shared-id>
        <span *ngIf="!order.bd2_result && !order.bd2_evaluation_id"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="BD5">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">BD5</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.bd5_result"
          (click)="onDecidoClick(order, order.bd5_evaluation_id); $event.stopPropagation()"
          [ngClass]="getEvaluationClass(order.bd5_result)"
          class="sp-text__ellipsized sp-text__hover sp-text__bold">
          {{ order.bd5_result | uppercase }}
        </span>
        <app-shared-id
          *ngIf="!order.bd5_result && order.bd5_evaluation_id"
          (click)="onDecidoClick(order, order.bd5_evaluation_id); $event.stopPropagation()"
          [content]="order.bd5_evaluation_id"
          [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover'"
          [is_shrinked_id]="true"></app-shared-id>
        <span *ngIf="!order.bd5_result && !order.bd5_evaluation_id"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div
          [ngClass]="getOrderStatusClass(order.status)"
          class="sp-order__status-radius sp-row__center sp-padding__horiz">
          <span class="sp-text__ellipsized sp-text__center">{{
            getOrderStatusLabel(order.status || '-') | translate | lowercase
          }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="store">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'GENERAL.STORE_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <app-shared-store-logo
            size="m"
            [current_store_logo]="order?.store_logo"></app-shared-store-logo>
          <span class="sp-text__ellipsized sp-margin__left">
            <b> {{ order.store_name || '-' }} </b>
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.BUYER_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.buyer_firstname"
          class="sp-text__ellipsized">
          <b>
            {{ getFullName(order).length > 30 ? (getFullName(order) | slice : 0 : 30) + '...' : getFullName(order) }}
          </b>
        </span>

        <span
          *ngIf="!order.buyer_firstname && order.buyer_phone"
          class="sp-text__ellipsized">
          <b>{{ order.buyer_phone.prefix || '-' }} {{ order.buyer_phone.value || '' }}</b>
        </span>

        <span *ngIf="!order.buyer_firstname && !order.buyer_phone">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tax_deduction">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.TAX_DEDUCTION_SHORT_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <p class="sp-text__ellipsized sp-text__center">
          {{ order.tax_deduction ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate) }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.AMOUNT_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <button
          (click)="onOrderAmountClick(order); $event.stopPropagation()"
          mat-icon-button>
          <mat-icon class="material-symbols-outlined sp-color__primary"> visibility </mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="instalments">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.INSTALMENTS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <p class="sp-text__ellipsized sp-text__center">
          {{ order.summary.total || '-' }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <button
            (click)="onOrderDetailClick(order.store_id, order.order_id); $event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"
      class="sp-cursor__pointer"
      (click)="onOrderDetailClick(row.store_id, row.order_id)"></tr>
  </table>
</div>
